module.exports = __webpack_public_path__ + "fonts/pizzagame.79166afa.woff2";